import {OrderItems} from "../../component/OrderItems";
import {DataTable} from "../../component/datatable/DataTable";
import {formatPrice, germanDate, sumItemsDouble} from "../../js/util";
import {SelectOne} from "../../component/form/SelectOne";
import {orderStateLabels, yearsOptions} from "../../js/constants";
import {BreadCrumb} from "../../component/Breadcrumb";
import {SelectReact} from "../../component/form/SelectReact";
import {useEffect, useRef, useState} from "react";
import {get} from "../../js/api";

export const getOrderStateTag = (state) => {
    const msg = getOrderStateText(state);
    switch (state) {
        case "CREATED":
            return <span className="lightgrey">{msg}</span>;
        case "OPEN":
        case "PAID":
            return <span className="red">{msg}</span>;
        case "IN_PROGRESS":
        case "IN_PRODUCTION":
            return <span className="orange">{msg}</span>;
        case "AWAIT_USER":
            return <span className="lightgrey">{msg}</span>
        case "AWAIT_PAYMENT":
            return <span className="lightgrey">{msg}</span>;
        case "CANCELED":
            return <span className="grey">{msg}</span>;
        case "COMPLETED":
            return <span className="green">{msg}</span>;
        default:
            return state;
    }
};

export const getOrderStateText = (state) => {
    return orderStateLabels.get(state);
}

export const Overview = ({orders, selectedYear, setSelectedYear}) => {

    const augmentedIds = useRef(new Map());
    const [augmentedOrders, setAugmentedOrders] = useState(orders);

    useEffect(() => {
        setAugmentedOrders(orders)
        augmentedIds.current.clear();
    }, [orders]);

    const columns = [
        {
            name: "Bestellnummer",
            selector: (row) => row.id,
            sortable: true
        },
        {
            name: "Datum",
            selector: (row) => germanDate(row.creationDate),
            sortable: true,
            sortFunction: (first, second) => first.creationDate - second.creationDate
        },
        {
            name: "Beschreibung",
            selector: (row) => row.summary,
            sortable: true,
        },
        {
            name: "Status",
            selector: (row) => getOrderStateTag(row.state),
            sortFunction: (first, second) => getOrderStateText(first.state).localeCompare(getOrderStateText(second.state)),
            sortable: true
        },
        {
            name: "Username",
            selector: (row) => row.username,
            maxWidth: '200px',
            sortable: true,
        },
        {
            name: "Summe (netto)",
            selector: (row) => formatPrice(row.sum),
            right: true,
            sortable: true,
            maxWidth: '200px',
            sortFunction: (first, second) => sumItemsDouble(first.items) - sumItemsDouble(second.items),
        },
        {
            name: "Interne Bestellnummer",
            selector: (row) => row.internalOrderId,
            omit: true
        },
    ];

    const loadDetail = (row) => {
        if(!augmentedIds.current.has(row.id)){
            augmentedIds.current.set(row.id, false);
            get(`/orders/${row.id}`).then(detailed => {
                setAugmentedOrders(current => {
                    if(!current || !current.some(o => o.id === row.id)){
                        return current;
                    }
                    augmentedIds.current.set(detailed.id, true);
                    return current.map(o => o.id === row.id ? detailed : o);
                });
            });
        }
    }

    const rowExpanded = (expanded, row) => {
        if(expanded){
            loadDetail(row)
        }
    }

    return (
        <div>
            <BreadCrumb currentTitle="Meine Bestellungen"/>
            <div className="data-table">
                <DataTable data={augmentedOrders}
                           columns={columns}
                           expandableRows
                           expandOnRowClicked
                           onRowExpandToggled={rowExpanded}
                           expandableRowsComponent={OrderItems}
                           expandableRowsComponentProps={{'inline': true}}
                           actions={<SelectReact value={selectedYear} setter={setSelectedYear} options={yearsOptions}/>}/>
            </div>

        </div>
    );

};
